import { render, staticRenderFns } from "./TipList.vue?vue&type=template&id=b0b481b8&"
import script from "./TipList.vue?vue&type=script&lang=js&"
export * from "./TipList.vue?vue&type=script&lang=js&"
import style0 from "./TipList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports